import { Eye, PiggyBank, Sprout, Trash2 } from "lucide-react";
import { formatEuro } from "@/lib/dates";

const CARDS = [
  { key: "active", label: "À surveiller", icon: Eye, fmt: (v) => v, color: "text-foreground" },
  { key: "saved", label: "Produits sauvés", icon: Sprout, fmt: (v) => v, color: "text-primary" },
  { key: "money_saved", label: "Économisé", icon: PiggyBank, fmt: formatEuro, color: "text-primary" },
  { key: "money_wasted", label: "Gaspillé", icon: Trash2, fmt: formatEuro, color: "text-destructive" },
];

export default function StatsBar({ stats }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="stats-bar">
      {CARDS.map(({ key, label, icon: Icon, fmt, color }) => (
        <div key={key} className="bg-card border border-border rounded-2xl p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] card-hover" data-testid={`stat-${key}`}>
          <div className="flex items-center justify-between">
            <span className="mono text-[10px] uppercase tracking-mono text-muted-foreground">{label}</span>
            <Icon className={`h-4 w-4 ${color}`} />
          </div>
          <p className={`font-mono font-bold text-2xl mt-2 ${color}`}>{fmt(stats?.[key] ?? 0)}</p>
        </div>
      ))}
    </div>
  );
}
